export default {
    name: 'cookieBar',
    components: {},
    data() {
        return {
            show: false,
        }
    },
    methods: {
        agree() {
            this.show = false
            localStorage.setItem('cookieShow', 'true')
        },
        leave() {
            this.$router.push("/")
            this.show = false
            localStorage.setItem('cookieShow', 'false')
        }
    },
    created() {
        if ((localStorage.getItem('cookieShow') === 'false' || localStorage.getItem('cookieShow') === null) && !Boolean(this.$route.params.name)) {
            this.show = true
        }
    }
}
